import { Directive } from '@angular/core';

@Directive({
  selector: '[xpoTileRibbonMini]',
  host: {
    class: 'xpo-TileRibbon--mini',
  },
})
export class XpoTileRibbonMiniDirective {}
